import { useQuery } from "@tanstack/react-query";
import type { PaymentLinkGetByCodeResponseType } from "@sellar-io/api-v2/types";
import {
  apiV2AssertResponse,
  type ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePaymentLinkGetByCode = (
  code: string,
  options?: ApiV2QueryOptions<PaymentLinkGetByCodeResponseType>,
) => {
  return useQuery({
    queryKey: [ServerStateKeys.PaymentLink, "ref", code],
    queryFn: () =>
      apiV2Request({
        method: "get",
        path: `payment-link/ref/${code}`,
        business: null,
      }).then(
        (data) =>
          apiV2AssertResponse<PaymentLinkGetByCodeResponseType>(data).data,
      ),
    enabled: !!code,
    ...getDefaultQueryOptions(options),
  });
};
